// shell
import { useIsBusy } from "../../common/shell/shellHelper";

export default function BusyOverlayController() {
    const isBusy = useIsBusy();

    return <LoadingPanel isBusy={isBusy} />;
}

function LoadingPanel(props: { isBusy: boolean }) {
    const isBusy = props.isBusy;

    if (!isBusy) return <></>;

    return (
        <div className="k-loading-mask">
            <span className="k-loading-text">Loading</span>
            <div className="k-loading-image"></div>
            <div className="k-loading-color"></div>
        </div>
    );
}
